import { Flex } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { WeightScalesIcon } from "ui/Icons/Icons";
import { Status } from "ui/Status/Status";

import { ProductState } from "../stores/pickingTypes";

type PickingProductCardStatusTagsProps = {
  state: ProductState;
  isSkippedItem: boolean;
  hasMissingItems: boolean;
  isVariablePriceItem?: boolean;
  skippedItemPendingStatusLabel?: string;
  skippedItemRefundStatusLabel?: string;
};

export function PickingProductCardStatusTags({
  state,
  isSkippedItem,
  hasMissingItems,
  isVariablePriceItem = false,
  skippedItemPendingStatusLabel,
  skippedItemRefundStatusLabel,
}: PickingProductCardStatusTagsProps) {
  const isPending = state !== "DONE";
  const intl = useIntl();
  return (
    <Flex>
      {isVariablePriceItem && (
        <Status
          label={
            isPending && !isSkippedItem
              ? intl.formatMessage({
                  id: "components.picking.status-tags.weight-based-pricing",
                })
              : ""
          }
          textColor="white"
          size="small"
          fontSize="0.75rem"
          w="max-content"
          bgColor="blue.500"
          mr="s50"
          icon={<WeightScalesIcon boxSize="24px" color="white" />}
        />
      )}
      {state === "DONE" && !hasMissingItems && (
        <Flex width="fit-content" h="40px">
          <Status
            label={intl.formatMessage({ id: "components.picking.status-tags.picked" })}
            textColor="white"
            mr="s50"
            size="small"
            fontSize="0.75rem"
            w="max-content"
            bgColor="veggie.500"
          />
        </Flex>
      )}

      {isSkippedItem && (
        <Flex width="fit-content" h="40px">
          {(isPending || hasMissingItems) && (
            <Status
              label={
                isPending
                  ? (skippedItemPendingStatusLabel ?? "")
                  : (skippedItemRefundStatusLabel ?? "")
              }
              textColor={isPending ? "orange.500" : "white"}
              mr="s50"
              size="small"
              fontSize="0.75rem"
              h="40px"
              bg={isPending ? "orange.100" : "orange.500"}
            />
          )}
        </Flex>
      )}
    </Flex>
  );
}
